(function () {
    'use strict';

    angular.module('bizmetryApp').component('twoFaValidator', {

        bindings: {
            email:        '@',
            targetNumber: '@',
            onSuccess:    '&',
            onCancel:     '&'
        },

        template: `
            <div class="tfa-validator">

                <!-- Header -->
                <div class="tfa-validator__header">
                    <div class="tfa-validator__icon"
                         ng-class="{ 'tfa-validator__icon--success': $ctrl.success }">
                        <i class="material-icons" ng-if="!$ctrl.success">security</i>
                        <i class="material-icons" ng-if="$ctrl.success">check_circle</i>
                    </div>
                    <h2 class="tfa-validator__title">Two-Factor Authentication</h2>
                    <p class="tfa-validator__subtitle">
                        A two-factor token has been sent to your registered trusted device.
                        Please enter the number you have received.
                    </p>
                </div>

                <!-- Countdown -->
                <div class="tfa-validator__countdown" ng-if="!$ctrl.success">
                    <span ng-if="!$ctrl.expired && !$ctrl.rateLocked"
                          class="tfa-validator__countdown-timer"
                          ng-class="{ 'tfa-validator__countdown-timer--warning': $ctrl.countdown <= 30 }">
                        <i class="material-icons">timer</i>
                        Code expires in {{ $ctrl.countdown }}s
                    </span>
                    <span ng-if="$ctrl.expired && !$ctrl.rateLocked" class="tfa-validator__countdown-expired">
                        <i class="material-icons">timer_off</i>
                        Code expired
                    </span>
                    <span ng-if="$ctrl.rateLocked" class="tfa-validator__countdown-expired">
                        <i class="material-icons">lock</i>
                        Too many attempts — try again in {{ $ctrl.rateLockRemaining }}s
                    </span>
                </div>

                <!-- Digit inputs -->
                <div class="tfa-validator__inputs"
                     ng-if="!$ctrl.success"
                     ng-paste="$ctrl.onPaste($event)">
                    <input
                        ng-repeat="digit in $ctrl.digits track by $index"
                        type="tel"
                        maxlength="1"
                        class="tfa-validator__input"
                        ng-class="{
                            'tfa-validator__input--filled':   $ctrl.digits[$index] !== '',
                            'tfa-validator__input--error':    $ctrl.errorMessage,
                            'tfa-validator__input--disabled': $ctrl.expired || $ctrl.loading || $ctrl.rateLocked
                        }"
                        ng-model="$ctrl.digits[$index]"
                        ng-disabled="$ctrl.expired || $ctrl.loading || $ctrl.rateLocked"
                        ng-keydown="$ctrl.onDigitKeydown($index, $event)"
                        ng-change="$ctrl.onDigitChange($index)"
                        autocomplete="one-time-code" />
                </div>

                <!-- Success state -->
                <div class="tfa-validator__success-msg" ng-if="$ctrl.success">
                    <i class="material-icons">verified_user</i>
                    Identity verified successfully.
                </div>

                <!-- Error message -->
                <div class="tfa-validator__error" ng-if="$ctrl.errorMessage && !$ctrl.rateLocked">
                    <i class="material-icons">error_outline</i>
                    {{ $ctrl.errorMessage }}
                </div>

                <!-- Loading bar -->
                <div class="tfa-validator__loading" ng-if="$ctrl.loading">
                    <md-progress-linear md-mode="indeterminate"></md-progress-linear>
                </div>

                <!-- Actions -->
                <div class="tfa-validator__actions" ng-if="!$ctrl.success">
                    <md-button class="tfa-validator__btn-resend"
                               ng-click="$ctrl.resendCode()"
                               ng-disabled="$ctrl.loading || $ctrl.rateLocked">
                        <i class="material-icons">refresh</i>
                        Resend code
                    </md-button>
                    <span flex></span>
                    <md-button class="md-button"
                               ng-click="$ctrl.cancel()"
                               ng-disabled="$ctrl.loading">
                        Cancel
                    </md-button>
                </div>

            </div>
        `,

        controller: ['$interval', '$timeout', 'TwoFaService',
            function ($interval, $timeout, TwoFaService) {

                var $ctrl = this;
                var CODE_LENGTH      = 6;
                var COUNTDOWN_SECS   = 120;
                var MAX_ATTEMPTS     = 6;
                var RATE_WINDOW_MS   = 60 * 1000;   // ventana de 1 minuto
                var _timer           = null;
                var _rateLockTimer   = null;

                // ── Rate limiting state ────────────────────────────────────
                var _attemptTimestamps = [];   // timestamps de cada intento en la ventana

                // ── Lifecycle ──────────────────────────────────────────────
                $ctrl.$onInit = function () {
                    _reset();
                    _generateToken();
                };

                $ctrl.$onDestroy = function () {
                    _cancelTimer();
                    _cancelRateLockTimer();
                };

                // ── Internal helpers ───────────────────────────────────────
                function _reset() {
                    $ctrl.digits          = new Array(CODE_LENGTH).fill('');
                    $ctrl.countdown       = COUNTDOWN_SECS;
                    $ctrl.expired         = false;
                    $ctrl.loading         = false;
                    $ctrl.errorMessage    = null;
                    $ctrl.success         = false;
                    $ctrl.rateLocked      = false;
                    $ctrl.rateLockRemaining = 0;
                }

                function _cancelTimer() {
                    if (_timer) {
                        $interval.cancel(_timer);
                        _timer = null;
                    }
                }

                function _cancelRateLockTimer() {
                    if (_rateLockTimer) {
                        $interval.cancel(_rateLockTimer);
                        _rateLockTimer = null;
                    }
                }

                function _startCountdown() {
                    _cancelTimer();
                    $ctrl.countdown = COUNTDOWN_SECS;
                    $ctrl.expired   = false;

                    _timer = $interval(function () {
                        $ctrl.countdown--;
                        if ($ctrl.countdown <= 0) {
                            $ctrl.expired = true;
                            _cancelTimer();
                        }
                    }, 1000);
                }

                // ── Rate limit ─────────────────────────────────────────────
                function _pruneAttempts() {
                    var cutoff = Date.now() - RATE_WINDOW_MS;
                    _attemptTimestamps = _attemptTimestamps.filter(function (ts) {
                        return ts > cutoff;
                    });
                }

                function _isRateLimited() {
                    _pruneAttempts();
                    return _attemptTimestamps.length >= MAX_ATTEMPTS;
                }

                function _registerAttempt() {
                    _attemptTimestamps.push(Date.now());
                }

                function _engageRateLock() {
                    _cancelRateLockTimer();
                    $ctrl.rateLocked       = true;
                    $ctrl.errorMessage     = null;

                    // Tiempo hasta que el intento más antiguo salga de la ventana
                    var oldestTs      = _attemptTimestamps[0];
                    var unlockAt      = oldestTs + RATE_WINDOW_MS;
                    var secsRemaining = Math.ceil((unlockAt - Date.now()) / 1000);

                    $ctrl.rateLockRemaining = secsRemaining > 0 ? secsRemaining : 0;

                    _rateLockTimer = $interval(function () {
                        $ctrl.rateLockRemaining--;
                        if ($ctrl.rateLockRemaining <= 0) {
                            _cancelRateLockTimer();
                            _pruneAttempts();
                            $ctrl.rateLocked = false;
                            _clearDigits();
                        }
                    }, 1000);
                }

                // ── Token generation ───────────────────────────────────────
                function _generateToken() {
                    $ctrl.loading      = true;
                    $ctrl.errorMessage = null;

                    var promise = $ctrl.targetNumber
                        ? TwoFaService.generateTokenWithNumber($ctrl.email, $ctrl.targetNumber)
                        : TwoFaService.generateToken($ctrl.email);

                    promise
                        .then(function (data) {
                            if (data && data.expiresAt) {
                                var secsRemaining = Math.floor((data.expiresAt - Date.now()) / 1000);
                                COUNTDOWN_SECS = secsRemaining > 0 ? secsRemaining : COUNTDOWN_SECS;
                            }
                            _startCountdown();
                        })
                        .catch(function (err) {
                            $ctrl.errorMessage = (err.data && err.data.message)
                                ? err.data.message
                                : 'Failed to send 2FA code. Please try again.';
                        })
                        .finally(function () {
                            $ctrl.loading = false;
                        });
                }

                function _getInputs() {
                    return document.querySelectorAll('.tfa-validator__input');
                }

                function _focusInput(index) {
                    $timeout(function () {
                        var inputs = _getInputs();
                        if (inputs[index]) inputs[index].focus();
                    }, 30);
                }

                function _isComplete() {
                    return $ctrl.digits.every(function (d) { return d !== ''; });
                }

                function _clearDigits() {
                    $ctrl.digits = new Array(CODE_LENGTH).fill('');
                    _focusInput(0);
                }

                function _validate() {
                    // Verificar rate limit antes de lanzar la llamada
                    if (_isRateLimited()) {
                        _engageRateLock();
                        _clearDigits();
                        return;
                    }

                    _registerAttempt();

                    // Si este intento agota el límite, bloquear inmediatamente
                    if (_isRateLimited()) {
                        _engageRateLock();
                        _clearDigits();
                        return;
                    }

                    var code           = $ctrl.digits.join('');
                    $ctrl.loading      = true;
                    $ctrl.errorMessage = null;

                    TwoFaService.validateToken($ctrl.email, code)
                        .then(function () {
                            $ctrl.success = true;
                            _cancelTimer();
                            $timeout(function () {
                                $ctrl.onSuccess({ code: $ctrl.digits.join('') });
                            }, 800);
                        })
                        .catch(function (err) {
                            var errorCode = err.data && err.data.error_code;

                            if (errorCode === '2FA_CODE_EXPIRED') {
                                $ctrl.expired      = true;
                                $ctrl.errorMessage = 'Your code has expired. Please request a new one.';
                            } else if (errorCode === '2FA_CODE_INVALID') {
                                $ctrl.errorMessage = 'Incorrect code. Please try again.';
                                _clearDigits();
                            } else {
                                $ctrl.errorMessage = (err.data && err.data.message)
                                    ? err.data.message
                                    : 'Validation failed. Please try again.';
                                _clearDigits();
                            }
                        })
                        .finally(function () {
                            $ctrl.loading = false;
                        });
                }

                // ── Public handlers ────────────────────────────────────────
                $ctrl.onDigitChange = function (index) {
                    var value = $ctrl.digits[index];

                    if (!/^\d$/.test(value)) {
                        $ctrl.digits[index] = '';
                        return;
                    }

                    if (index < CODE_LENGTH - 1) {
                        _focusInput(index + 1);
                    }

                    if (_isComplete()) {
                        _validate();
                    }
                };

                $ctrl.onDigitKeydown = function (index, event) {
                    if (event.key === 'Backspace') {
                        if ($ctrl.digits[index]) {
                            $ctrl.digits[index] = '';
                        } else if (index > 0) {
                            $ctrl.digits[index - 1] = '';
                            _focusInput(index - 1);
                        }
                    }
                };

                $ctrl.onPaste = function (event) {
                    event.preventDefault();
                    var pasted = (event.clipboardData || window.clipboardData).getData('text');
                    var digits = pasted.replace(/\D/g, '').slice(0, CODE_LENGTH);

                    digits.split('').forEach(function (d, i) {
                        $ctrl.digits[i] = d;
                    });

                    _focusInput(Math.min(digits.length - 1, CODE_LENGTH - 1));

                    if (_isComplete()) {
                        _validate();
                    }
                };

                $ctrl.resendCode = function () {
                    _attemptTimestamps = [];   // resend limpia el historial de intentos
                    _cancelRateLockTimer();
                    $ctrl.rateLocked = false;
                    _clearDigits();
                    _generateToken();
                };

                $ctrl.cancel = function () {
                    _cancelTimer();
                    _cancelRateLockTimer();
                    if ($ctrl.onCancel) {
                        $ctrl.onCancel();
                    }
                };

            }]

    });

}());